import React, { Fragment } from 'react'
import { Breadcrumbs } from '../../../../AbstractElements';
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import MTDReportView from './MTDReportView';

const MTDReport = () => {
    return (
        <Fragment>
            <Breadcrumbs parent="Report" title="MTD Report" mainTitle="MTD Sales Report" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <MTDReportView />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default MTDReport